import { INTERFACE } from '@/utils/INTERFACE';
import { getPlatform, isApp } from '@/utils/page';
import translate from '@/utils/translate';
import toast from '@/v-ui/Toast';
import $ from 'jquery';
import Cookies from 'js-cookie';
import { favor, isFavor, removeFavor } from '../../api/shopFavor';
import manager from '../manager';

manager.add('follow', {
  async created() {
	var jdPin=Cookies.get('pin')
	var btn=$(this.dom)
	var isFavoriteShop=await isFavor()
	setFollow(isFavoriteShop)
	function setFollow(flag){
		if(flag){
			btn.addClass("following")
		}else{
			btn.removeClass("following")
		}
	}
	btn.on("click",async function(){
		if(!jdPin){
			var {platform}=getPlatform()
			if(isApp()&&INTERFACE().login['app']){
				platform='app'
			}
			location.href=INTERFACE().login[platform]
			return
		}
		if(btn.hasClass("following")){
			try{
				await removeFavor()
			}catch(err){
				return
			}
			toast(translate("Successfully removed from favorite stores."))
			setFollow(false)
		}else{
			try{
				await favor()
			}catch(err){
				return
			}
			toast(translate("Successfully added favorite stores."))
			setFollow(true)
		}

	})
  },
  destroyed() {
	$(this.dom).off("click")
  }
})